<template>
    <v-checkbox @click="$emit('input', checked ? '1' : '')" v-model="checked" :rules="rules">
        <span slot="label" v-html="label + (required ? ' *': '')" @click.stop></span>
    </v-checkbox>
</template>

<script>
    export default {
        name: 'GenericCheckboxField',
        data:()=>({
            checked: false
        }),
        props: {
            label: String,
            required: Boolean,
        },
        computed: {
            rules() {
                return [
                    v => !this.required || !!v || this.$t('login.fields.rules.required')
                ]
            }
        }
    };
</script>

<style scoped>

</style>